module.exports = __webpack_public_path__ + "img/skills-mosaic-asn-1.2b52f82f.png";